<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { computed, inject, provide, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Images
import strixiLogo from '@/../img/logo.svg';

// Components
import Navigation from '@/Components/Navigation/Navigation.vue';
import NavigationMobileIcon from '@/Components/Navigation/NavigationMobileIcon.vue';
import LanguageSwitcher from '@/Components/LanguageSwitcher.vue';
import TopHeader from '@/Components/TopHeader.vue';
import WhatsappButton from '@/Components/WhatsappButton.vue';

const showBar = computed(() => usePage().props.template_options.header.show_header_bar);
const whatsappActive = computed(() => usePage().props.template_options.modules.whatsapp_active);
const templateLogo = computed(() => usePage().props.template_options.global.logo);
const logoHeight = computed(() => usePage().props.template_options.global.logo_height);

const route = inject('route');
const { t } = useI18n();

const menuItems = computed(() => usePage().props.menus.find((header) => header.name == 'Header'));
const openMobileMenu = ref(false);

provide('openMobileMenu', openMobileMenu);
</script>

<template>
    <header class="fixed left-0 top-0 z-40 w-full">
        <TopHeader v-if="showBar" />
        <div class="from-primary-medium bg-white bg-gradient-to-r to-secondary py-6 shadow-sm">
            <div class="container">
                <div
                    x-data="{ open: false }"
                    class="mx-auto flex flex-col xl:flex-row xl:items-center xl:justify-between"
                >
                    <div class="flex flex-row items-center justify-between">
                        <Link
                            v-if="templateLogo"
                            :href="'/'"
                            class="shrink-0"
                        >
                            <img
                                :height="logoHeight"
                                :style="`height:${logoHeight}px`"
                                :src="`/storage/` + templateLogo"
                                alt="Logo"
                            >
                        </Link>

                        <Link
                            v-else
                            :href="'/'"
                            class="shrink-0"
                        >
                            <img
                                :height="logoHeight"
                                :style="`height:${logoHeight}px`"
                                :src="strixiLogo"
                                alt="Logo"
                            >
                        </Link>

                        <div class="flex gap-4 xl:hidden">
                            <LanguageSwitcher :class="{ hidden: !openMobileMenu }" />

                            <NavigationMobileIcon :open-mobile-menu="openMobileMenu" />
                        </div>
                    </div>

                    <div
                        class="absolute left-0 top-[107px] w-screen gap-10 bg-gray-light text-black xl:relative xl:top-0 xl:flex xl:w-auto xl:items-center xl:bg-transparent"
                    >
                        <div :class="{ 'container z-20 h-screen w-full pt-16 xl:h-auto xl:pt-0': openMobileMenu }">
                            <div class="flex gap-8">
                                <Navigation :menu-items="menuItems.contents" />

                                <LanguageSwitcher class="hidden xl:block" />
                            </div>

                            <div
                                class="relative z-20 mt-8 flex flex-col items-start gap-3"
                                :class="{ hidden: !openMobileMenu }"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <WhatsappButton v-if="whatsappActive" />
    </header>
    <div :class="showBar ? 'min-h-30' : 'min-h-20'" />
</template>
